import { IconButton, InputBase, Pagination } from '@mui/material'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AdminButton } from '../../components/mui'
import { Search } from '@mui/icons-material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
const TestThree = () => {
  const navigate=useNavigate()
  function handleNavigate(){
navigate("/admin/payment/detail")
  }
  useEffect(()=>{
    document.title = "RollingAdz: Payments" || "Default Title";
  },[])
  return (
    <>
    <div className="input-main my-2">
      <div className='d-flex col-md-6 justify-content-between align-items-center'>
                        <label className="blue-txt">
                          Invoices &amp; Invoice Status
                        </label>
                        <div className=' d-flex'  style={{backgroundColor:"#f1f1f5",borderRadius:"50px"}}>
  <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        <Search />
      </IconButton>
      <InputBase className=''
        sx={{ ml: 1, flex: 1,px:2 }}
        placeholder="Search..."
       type='search'
      //  value={search}
      //  onChange={(e)=>setSearch(e.target.value)}
      //  onKeyUp={handleSubmit}
         />
    </div></div>
                        <div className="table-responsive mt-1">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Date <FilterAltOutlinedIcon/></th>
                                <th>Invoice # <FilterAltOutlinedIcon/></th>
                                <th>Amount <FilterAltOutlinedIcon/></th>
                                <th>Status <FilterAltOutlinedIcon/></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-success" />
                                    <span>Paid</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-danger" />
                                    <span>Unpaid</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-warning " />
                                    <span>Pending</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-danger" />
                                    <span>Unpaid</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-success" />
                                    <span>Paid</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-danger" />
                                    <span>Unpaid</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-warning " />
                                    <span>Pending</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-danger" />
                                    <span>Unpaid</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/20/22</td>
                                <td>#324567</td>
                                <td>$200.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-success" />
                                    <span>Paid</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              <tr>
                                <td>11/25/22</td>
                                <td>#654783</td>
                                <td>$250.0</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <i className="bi bi-circle-fill text-danger" />
                                    <span>Unpaid</span>
                                  </div>
                                </td>
                                <td>
                              <AdminButton onClick={handleNavigate} name={"Detail"}/>
                                
                                </td>
                              </tr>
                              
                            </tbody>
                          </table>
                          <div className='d-flex justify-content-end me-5'>

                          <Pagination count={10} shape="rounded" />
                          </div>
                        </div>
                      </div>
    </>
  )
}

export default TestThree